import axios from "axios";

// const storeId = "88026380";
const storeId = "88026380";
// const publicToken = "secret_tCeDaKfQgTEMUcKzrCpUdXJwU2N5nC8W";
// const publicToken = "secret_kRcPTGe3QT5ra6F4Jn2mP9xwuGk2ZbCL";
const publicToken = "secret_Jx3TRcj9PWcuhpjsygNwRfkpyUytxtDg"

const api = axios.create({
  baseURL: `https://app.ecwid.com/api/v3/${storeId}`,
  headers: {
    Authorization: `Bearer ${publicToken}`,
  },
  timeout: 10000,
});

export const getCategories = () => {
  return api.get("/categories").then((res) => res.data.items);
};

export const getProducts = (categoryId = null, cancelToken = null) => {
  const url = categoryId ? `/products?category=${categoryId}` : "/products";
  return api.get(url, { cancelToken }).then((res) => res.data.items);
};
